<template>
  <div class="comblock">
    <div class="topbox">
      <!-- 收获地址 -->
      <div class="Harvestaddress">
        <h1>{{ $fanyi('收货地址') }}</h1>
        <!-- 收件人 -->
        <div>
          <span>{{ $fanyi('收件人') }}</span>
          <span>{{ datas.result.receive
            ? datas.result.receive.contacts ? datas.result.receive.contacts : '-------'
            : '-------' }}</span>
        </div>
        <!-- 手机号 -->
        <div>
          <span>{{ $fanyi('手机号') }}</span>
          <span>{{ datas.result.receive
            ? datas.result.receive.mobile ? datas.result.receive.mobile : '--------'
            : '--------' }}</span>
        </div>
        <!-- 电子邮箱 -->
        <div>
          <span>{{ $fanyi('电子邮箱') }}</span>
          <span> {{
            datas.result.receive
              ? datas.result.receive.email ? datas.result.receive.email : '--------'
              : '--------'
          }}</span>
        </div>
        <!-- 地址 -->
        <div>
          <span>{{ $fanyi('地址') }}</span>
          <span> {{
            datas.result.receive
              ? datas.result.receive.address ? datas.result.receive.address : '--------'
              : '--------'
          }}</span>
        </div> <!-- 邮编 -->
        <div>
          <span>{{ $fanyi('邮编') }}</span>
          <span> {{
            datas.result.receive
              ? datas.result.receive.zip_code ? datas.result.receive.zip_code : '--------'
              : '--------'
          }}</span>
        </div>
        <div> <!-- 城市 -->
          <span>{{ $fanyi('城市') }}</span>
          <span> {{
            datas.result.receive
              ? datas.result.receive.city ? datas.result.receive.city : '--------'
              : '--------'
          }}</span>
        </div>

      </div>
      <!-- 国际费用明细 -->
      <div class="Internationalchargedetail" v-loading.fullscreen.lock="fullscreenLoading">


        <h1>{{ $fanyi('国际费用明细') }}</h1>
        <p>
          <label>{{ $fanyi('国际物流费用') }}：</label><span>₴ {{ $fun.EURNumSegmentation(datas.result.logistics_price)
          }}</span>
        </p>
        <p>
          <label>{{ $fanyi('乌克兰物流费用') }}：</label><span>₴ {{ $fun.EURNumSegmentation(datas.result.foreign_express_price)
          }}
          </span>
        </p>
        <p>
          <label>{{ $fanyi('其他费用') }}：</label><span>₴ {{ $fun.EURNumSegmentation(datas.result.other_price) }}</span>
        </p>
        <!-- <p>
          <label>{{ $fanyi("增值税") }}：</label><span>{{ $fun.EURNumSegmentation(datas.added_price) }} $</span>
        </p>
        <p>
          <label>{{ $fanyi("反倾销税") }}：</label><span>{{ $fun.EURNumSegmentation(datas.clearance_price) }} $</span>
        </p> -->

      </div>
    </div>
    <!--通关方式  -->
    <div class="tongguanbox">

      <!-- 通关方式 -->
      <div class="tongguan">

        <!-- 通关方式 -->
        <!-- <div class="way">
          <h1>{{ $fanyi('通关方式') }}:</h1>
          <div> {{ $parent.form.personal_clearance == 'yes' ? $fanyi('双清包税') : $parent.form.personal_clearance == 'no' ?
            $fanyi('自行交税通关') : '' }}</div>
        </div> -->
        <!-- 国际物流公司 -->
        <div class="wuliu">
          <h1>{{ $fanyi('选择国际运输公司') }}:</h1>

          <div>{{ $parent.form.logistics ? $parent.form.logistics : '' }}</div>
        </div>
      </div>

      <!-- 特殊备注 -->
      <div class="Specialremarks">
        <div class="moudletitle">{{ $fanyi('特殊要求备注') }}：</div>


        <textarea :disabled="true" v-model="$parent.form.client_remark"></textarea>

      </div>


    </div>

  </div>
</template>
<script>
import axios from 'axios'; import Europess from '@/api/wangZhi'
let Europe = Europess + '/client/'
export default {
  props: {
    datas: Object,
  }, data() {
    return {
      openBlock: true,
      fullscreenLoading: false,
    }
  },


  computed: {},
  created() {

  },
  methods: {

  },
}
</script>
<style lang="scss" scoped>
@import '../../../../../../../css/mixin.scss';

.comblock {
  margin-top: 30px;

  .topbox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;

    .Harvestaddress {
      width: 810px;

      background: #FFFFFF;
      border-radius: 20px;
      background: #FFFFFF;
      padding: 30px;
      border-radius: 20px;

      h1 {
        font-weight: bold;
        font-size: 16px;
        color: #121212;
        line-height: 20px;
        margin-bottom: 30px;
      }

      div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        min-height: 20px;

        span {
          &:first-child {
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            line-height: 16px;
          }

          &:last-child {
            font-weight: 400;
            font-size: 14px;
            max-width: 400px;
            display: flex;
            flex-wrap: wrap;
            color: #121212;
            text-align: right;
            line-height: 16px;
          }
        }
      }
    }

    .Internationalchargedetail {
      width: 560px;
      min-height: 310px;
      background: #FFFFFF;
      border-radius: 20px;
      padding: 30px;

      h1 {
        font-weight: bold;
        font-size: 16px;
        color: #121212;
        line-height: 20px;
        margin-bottom: 15px;
      }

      p {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 48px;
        border-bottom: 1px solid #DFDFDF;

        label {
          font-weight: 400;
          font-size: 14px;
          color: #121212;
          line-height: 20px;
        }

        span {
          font-weight: 400;
          font-size: 14px;
          color: #121212;
          line-height: 20px;
        }
      }

      .xiazai {
        margin-top: 20px;
        min-width: 160px;
        max-width: 180px;
        flex-shrink: 0;
        height: 40px;
        background: #FFFFFF;
        border-radius: 12px;
        border: 2px solid #D12A1D;
        padding: 0 15px;
        display: flex;

        &:hover {
          cursor: pointer;
        }

        color: #D12A1D;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .tongguanbox {
    display: flex;
    justify-content: space-between;

    .tongguan {
      margin-right: 30px;

      width: 320px;

      .way {
        width: 320px;
        min-height: 150px;
        background: #FFFFFF;
        border-radius: 20px;
        padding: 30px 20px;
        margin-bottom: 20px;

        h1 {
          font-weight: bold;
          font-size: 16px;
          color: #121212;
          line-height: 20px;
          margin-bottom: 18px;
        }

        div {
          font-weight: 400;
          font-size: 14px;
          color: #121212;
          line-height: 16px;
        }
      }

      .wuliu {
        width: 320px;
        // min-height: 130px;
        height: 100%;

        background: #FFFFFF;
        padding: 30px 20px;
        border-radius: 20px;

        h1 {
          font-weight: bold;
          font-size: 16px;
          color: #121212;
          line-height: 20px;
          margin-bottom: 18px;
        }

        div {
          font-weight: 400;
          font-size: 14px;
          color: #121212;
          line-height: 16px;
        }
      }
    }

    .Specialremarks {
      flex: 1;
      min-height: 300px;
      padding: 30px;
      background: #FFFFFF;
      border-radius: 20px;

      .moudletitle {
        font-weight: bold;
        font-size: 16px;
        color: #121212;
        line-height: 20px;
        margin-bottom: 30px;
      }

      textarea {
        width: 100%;
        height: 190px;
        background: #FAFAFA;
        border-radius: 10px;
        border: 1px solid #DFDFDF;

        padding: 15px;

      }
    }

  }
}
</style>
